'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const UsersIcon = createIcon({
    displayName: 'UsersIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M14.667 14v-1.333c0-1.243-.85-2.287-2-2.583m-2.334-7.89a2.668 2.668 0 010 4.945m1 6.861c0-1.242 0-1.864-.203-2.354a2.667 2.667 0 00-1.443-1.443C9.197 10 8.576 10 7.333 10h-2c-1.242 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443-.203.49-.203 1.111-.203 2.354M9 4.667a2.667 2.667 0 11-5.333 0 2.667 2.667 0 015.333 0z"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default UsersIcon
